import { Handler } from "pagedjs";
import createIndex from "@/views/readonly/studbook/util/createIndex";

class CustomHandler extends Handler {
    beforeParsed(content) {
        // console.log("timing:indexStart");
        createIndex(content, {
            spanClassIndex: "horse-name",
            indexElement: "book-index",
            alphabet: true,
        });
        // console.log("timing:indexDone");
    }

    // afterPageLayout() {
    //     console.log("timing:pageLayout");
    // }

    afterPreview() {
        // Resolve index page numbers once after layout is complete, replacing the
        // removed CSS target-counter() which caused O(n²) layout recalculations.
        const pageEls = [...document.querySelectorAll('.pagedjs_page')];
        document.querySelectorAll('.alphabetical-index-list a[href^="#"]').forEach(link => {
            const target = document.getElementById(link.getAttribute('href').slice(1));
            if (!target) return;
            const pageEl = target.closest('.pagedjs_page');
            if (!pageEl) return;
            link.textContent = pageEls.indexOf(pageEl) + 1;
        });

        // console.log("timing:afterPreview");
        // this console log is very important, do not remove it
        console.log("finishedLoading");
    }
}

export default CustomHandler;
